import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Datetime from "react-datetime";
import { Button, TextField } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { Checkbox } from "primereact/checkbox";
import AddMyNetwork from "../Network/AddMyNetwork";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";

const AddInward = (props) => {
  const [userId, setUserId] = useState("");
  const [outwardId, setOutwardId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [itemLength, setItemLength] = useState(0);
  const [formData, setFormData] = useState({
    inwardDate: new Date(),
    inwardDateErr: false,
    inwardDateErrText: "",
    orderId: "",
    orderIdErr: false,
    orderIdErrText: "",
    invoiceNo: "",
    invoiceNoErr: false,
    invoiceNoErrText: "",
    process: "",
    processErr: false,
    processErrText: "",
    processMultiplier: "",
    toWarehouse: "",
    toWarehouseErr: false,
    toWarehouseErrText: "",
    isApplyToAll: false,
    supplier: "",
    supplierErr: false,
    supplierErrText: "",
    gstin: "",
    remarks: "",
    totalAmountExcludingGST: "",
    totalAmountIncludingGST: "",
    isGst: false,
    isBatch: false,
  });

  const [itemList, setItemList] = useState([
    {
      itemId: "",
      itemName: "",
      hsnCode: "",
      hsnCodeName: "",
      brandId: "",
      brandName: "",
      gst: "",
      rateExcludingGST: "",
      rateIncludingGST: "",
      quantity: "",
      unit: "",
      unitName: "",
      totalAmountIncludingGST: "",
      mfgDate: "",
      lifeSpan: "",
      expiryDate: "",
      batchNo: "",
      toWarehouse: "",
      toWarehouseName: "",
      currentQuantity: "",
      remarks: "",
      barcodeNo: "",
      mrp: 0,
      amount: 0,
      // batchNoList: [],
    },
  ]);
  const [batchesList, setBatchesList] = useState({});
  const [dropdownData, setDropdownData] = useState({
    order: [],
    process: [],
    warehouse: [],
    supplier: [],
    product: [],
    hsnCode: [],
    brands: [],
    units: [],
    gstRates: [],
  });
  const [networkUserType, setNetworkUserType] = useState("");
  const [isAddNetwork, setIsAddNetwork] = useState(false);
  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.InwardId) {
      GetInwardById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetProductMaster(data);
        GetProcessMaster(data);
        GetWarehouseMaster(data);
        GetSupplierList(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetHSNCodeMaster(data);
        GetGSTMaster(data);
        GetOrderList(data);
      }
    } else {
      GetProductMaster(data);
      GetProcessMaster(data);
      GetWarehouseMaster(data);
      GetSupplierList(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetHSNCodeMaster(data);
      GetGSTMaster(data);
      GetOrderList(data);
    }
  }, []);

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));

          let itemBatchList = {};
          filterArry.forEach((product) => {
            itemBatchList[product.value] = product.Variant?.Batches.map(
              (batch) => ({
                ...batch,
                label: batch.BatchNo,
                value: batch._id,
              })
            );
          });
          // console.log({ itemBatchList });
          setBatchesList(itemBatchList);
        }
      })
      .catch((err) => {});
  };

  const GetProcessMaster = async (UserId) => {
    try {
      let params = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetProcessMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            setDropdownData((prevState) => ({
              ...prevState,
              process: response.Data.map((item) => ({
                ...item,
                label: item.ProcessName,
                value: item._id,
              })),
            }));
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetSupplierList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Supplier",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setDropdownData((prevState) => ({
            ...prevState,
            supplier: filterArry,
          }));
        }
      })
      .catch(() => {});
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setDropdownData((prevState) => ({
            ...prevState,
            warehouse: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          setDropdownData((prevState) => ({
            ...prevState,
            hsnCode: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetOrderList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetOrderItems, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            order: filterArry.map((item) => ({
              ...item,
              label: item.OrderNumber,
              value: item._id,
            })),
          }));
        }
      })
      .catch((err) => {});
  };

  const GetInwardById = async (UserId) => {
    try {
      let params = {
        UserId,
        InwardId: props.location.state.InwardId,
      };
      api
        .post(APIConstant.path.GetInwardById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              InwardDate,
              OrderId,
              OrderNo,
              InvoiceNo,
              Process,
              ProcessName,
              ProcessMultiplier,
              ToWarehouse,
              ToWarehouseName,
              IsApplyToAll,
              Supplier,
              SupplierName,
              GSTIN,
              Remarks,
              TotalAmountExcludingGST,
              TotalAmountIncludingGST,
              ItemList,
              _id,
              IsGst,
              IsBatch,
              TotalMRP,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              inwardDate: InwardDate,
              orderId: OrderId,
              orderNo: OrderNo,
              invoiceNo: InvoiceNo,
              process: Process,
              processName: ProcessName,
              processMultiplier: ProcessMultiplier,
              toWarehouse: ToWarehouse,
              toWarehouseName: ToWarehouseName,
              isApplyToAll: IsApplyToAll,
              supplier: Supplier,
              supplierName: SupplierName,
              gstin: GSTIN,
              remarks: Remarks,
              totalAmountExcludingGST: TotalAmountExcludingGST,
              totalAmountIncludingGST: TotalAmountIncludingGST,
              isBatch: IsBatch,
              isGst: IsGst,
              TotalMRP: TotalMRP,
            }));
            let tempItemList = ItemList.map((item) => ({
              _id: item._id,
              itemId: item.ItemId,
              itemName: item.ItemName,
              hsnCode: item.HSNCode,
              hsnCodeName: item.HSNCodeName,
              brandId: item.Brand,
              brandName: item.BrandName,
              gst: item.GST,
              rateExcludingGST: item.RateExcludingGST,
              rateIncludingGST: item.RateIncludingGST,
              quantity: item.Quantity,
              originalUnit: item.OriginalUnitId,
              unit: item.UnitId,
              unitName: item.UnitName,
              totalAmountIncludingGST: item.TotalAmountIncludingGST,
              mfgDate: item.MfgDate,
              lifeSpan: item.LifeSpan,
              expiryDate: item.ExpiryDate,
              // batchNoList: dropdownData.product
              //   .find((item) => item._id === item.ItemId)
              //   ?.Variant?.Batches.map((batch) => ({
              //     ...batch,
              //     label: batch.BatchNo,
              //     value: batch._id,
              //   })),
              batchNo: item.BatchNoId,
              batchNoName: item.BatchNo,
              toWarehouse: item.ToWarehouse,
              toWarehouseName: item.ToWarehouseName,
              currentQuantity: item.CurrentQuantity,
              remarks: item.Remarks,
              barcodeNo: item.BarcodeNo,
              mrp: item.MRP,
              amount: item.Amount,
            }));
            setOutwardId(_id);
            setItemList(tempItemList);
            setItemLength(ItemList.length);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const AddInward = async () => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const payload = {
        OutwardId: outwardId,
        InwardDate: formData.inwardDate,
        OrderId: formData.orderId,
        OrderNo: dropdownData.order.find(
          (item) => item.value === formData.orderId
        )?.label,
        InvoiceNo: formData.invoiceNo,
        Process: formData.process,
        ProcessName: dropdownData.process.find(
          (item) => item.value === formData.process
        )?.label,
        ProcessMultiplier: formData.processMultiplier,
        ToWarehouse: formData.toWarehouse,
        ToWarehouseName: dropdownData.warehouse.find(
          (item) => item.value === formData.toWarehouse
        )?.label,
        IsApplyToAll: formData.isApplyToAll,
        Supplier: formData.supplier,
        SupplierName: dropdownData.supplier.find(
          (item) => item.value === formData.supplier
        )?.label,
        GSTIN: formData.gstin,
        Remarks: formData.remarks,
        TotalAmountExcludingGST: formData.isGst
          ? formData.totalAmountExcludingGST
          : itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.mrp), 0) *
            itemList?.reduce((a, b) => Number(a) + Number(b.quantity), 0)
          : 0.0,
        TotalAmountIncludingGST: formData.totalAmountIncludingGST,
        ItemList: itemList.map((item) => {
          return {
            _id: item._id,
            ItemId: item.itemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.itemId
            )?.label,
            HSNCode: item.hsnCode,
            HSNCodeName: dropdownData.hsnCode.find(
              (obj) => obj.value === item.hsnCode
            )?.label,
            Brand: item.brandId,
            BrandName: dropdownData.brands.find(
              (obj) => obj.value === item.brandId
            )?.label,
            RateExcludingGST: item.rateExcludingGST,
            GST: item.gst,
            GSTName: dropdownData.gstRates.find((obj) => obj.value === item.gst)
              ?.label,
            RateIncludingGST: item.rateIncludingGST,
            Quantity: item.quantity,
            UnitId: item.unit,
            UnitName: dropdownData.units.find((obj) => obj.value === item.unit)
              ?.label,
            OriginalUnitId: item.originalUnit,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            MfgDate: item.mfgDate,
            LifeSpan: item.lifeSpan,
            ExpiryDate: item.expiryDate,
            BatchNoId: item.batchNo,
            BatchNo: batchesList[item.itemId]?.find(
              (obj) => obj.value === item.batchNo
            )?.label,
            ToWarehouse: item.toWarehouse,
            ToWarehouseName: dropdownData.warehouse.find(
              (dropdownItem) => dropdownItem.value === item.toWarehouse
            )?.label,
            CurrentQuantity: item.currentQuantity,
            Remarks: item.remarks,
            Barcode: item.barcode,
            MRP: item.mrp,
            Amount: item.amount,
          };
        }),
        UserId: userId,
        InwardId: outwardId,
        IsGst: formData?.isGst,
        IsBatch: formData?.isBatch,
        TotalMRP: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.mrp), 0) *
            itemList?.reduce((a, b) => Number(a) + Number(b.quantity), 0)
          : 0.0,
        TotalAmount: itemList?.length
          ? itemList?.reduce((a, b) => Number(a) + Number(b.quantity), 0) *
            itemList?.reduce((a, b) => Number(a) + Number(b.amount), 0)
          : 0.0,
      };

      api.post(APIConstant.path.AddUpdateInward, payload).then((res) => {
        if (res.Success == 1) {
          setLoading(false);
          cogoToast.success(res.Message);
          props.history.push({
            pathname: "/admin/inward",
            state: {
              InwardId: res.Data,
            },
          });
        } else {
          setLoading(false);
          cogoToast.error(res.Message);
        }
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const GetVariantByBarcode = async (Barcode, index) => {
    let params = { UserId: userId, Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemList((prev) => {
            const updated = [...prev];
            let itemData = response.Data;

            updated[index].itemId = itemData.value;
            updated[index].hsnCode = itemData.HSNCode;
            updated[index].gst = itemData.GstRate;
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;
            updated[index].lifeSpan = itemData.LifeSpan;
            updated[index].amount = itemData.amount;
            if (itemData.Variant) {
              updated[index].mrp = itemData.Variant.Mrp;
              updated[index].rateExcludingGST = itemData.Variant.Price;
              updated[index].rateIncludingGST = itemData.Variant.Price
                ? itemData.Variant.Price +
                  (itemData.Variant.Price * itemData.GstRate) / 100
                : "";
            }

            if (formData.isBatch && itemData.Batch) {
              let tempBatch = itemData.Batch;
              if (tempBatch) {
                updated[index].batchNo = tempBatch._id;
                updated[index].mfgDate = tempBatch.MfgDate;
                updated[index].expiryDate = tempBatch.ExpiryDate;
              }
            }

            return updated;
          });
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };
  const validate = () => {
    let isValid = true;

    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "inwardDate", label: "Date" },
      // { key: "orderId", label: "Order No" },
      { key: "invoiceNo", label: "Invoice No" },
      // { key: "process", label: "Process" },
      { key: "toWarehouse", label: "Warehouse" },
      { key: "supplier", label: "Supplier" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    let tempItems = [...itemList];

    tempItems = tempItems.map((item) => {
      const updatedItem = { ...item };

      const itemFields = [
        { key: "itemId", label: "Item" },
        // { key: "hsnCode", label: "HSNCode" },
        { key: "unit", label: "Unit" },
        // { key: "batchNo", label: "Batch No" },
        { key: "toWarehouse", label: "Warehouse" },
      ];

      itemFields.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(item[key])) {
          isValid = false;
          updatedItem[`${key}Err`] = true;
          updatedItem[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedItem[`${key}Err`] = false;
          updatedItem[`${key}ErrText`] = "";
        }
      });

      return updatedItem;
    });

    setItemList(tempItems);

    if (!itemList.length) {
      isValid = false;
      cogoToast.error("Please select items");
    }

    return isValid;
  };

  const handleFormChange = (value, field, regex) => {
    if (!value) {
      if (field === "lifeSpan") {
        let tempItems = [...itemList];
        tempItems.forEach((item) => {
          item.Batches.forEach((batch) => {
            batch.expiryDate = "";
          });
        });
        setItemList(tempItems);
      }
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        if (field === "hsnCode") {
          extraObj.gstRate = dropdownData.hsnCodes.find(
            (item) => item.value === value
          )?.GST;
        } else if (field === "subCategory") {
          extraObj.category = dropdownData.subCategories.find(
            (item) => item.value === value
          )?.Category;
        } else if (field === "lifeSpan") {
          let tempItems = [...itemList];
          tempItems.forEach((item, varIdx) => {
            item.Batches.forEach((batch, batchIdx) => {
              if (batch.mfgDate) {
                batch.expiryDate = moment(batch.mfgDate)
                  .add(parseInt(value), "days")
                  .toDate();
              }
            });
          });
          setItemList(tempItems);
        } else if (field === "isApplyToAll") {
          if (value && formData.toWarehouse) {
            let tempItemList = [...itemList];
            tempItemList.forEach((item) => {
              item.toWarehouse = formData.toWarehouse;
            });
            setItemList(tempItemList);
          }
        } else if (field === "toWarehouse") {
          if (value && formData.isApplyToAll) {
            let tempItemList = [...itemList];
            tempItemList.forEach((item) => {
              item.toWarehouse = value;
            });
            setItemList(tempItemList);
          }
        } else if (field === "orderId") {
          let tempOrder = dropdownData.order.find(
            (orderData) => orderData.value === value
          );
          if (tempOrder) {
            if (tempOrder.Items?.length) {
              let tempItems = [];
              let length = 0;
              tempOrder.Items.forEach((item) => {
                length += 1;
                let matchedItem = dropdownData.product.find(
                  (product) => product.value === item.ItemId
                );
                tempItems.push({
                  itemId: item.ItemId,
                  itemName: item.Item,
                  hsnCode: matchedItem.HSNCode,
                  hsnCodeName: matchedItem.HSNCodeName,
                  brandId: matchedItem.Brand,
                  brandName: matchedItem.BrandName,
                  gst: matchedItem.GstRate,
                  rateExcludingGST: "",
                  rateIncludingGST: "",
                  quantity: item.OrderQuantity,
                  unit: item.UnitId,
                  unitName: item.Unit,
                  originalUnit: matchedItem.UnitId,
                  totalAmountIncludingGST: "",
                  mfgDate: "",
                  lifeSpan: matchedItem.LifeSpan,
                  expiryDate: "",
                  batchNo: "",
                  toWarehouse: item.GodownId,
                  toWarehouseName: item.Godown,
                  currentQuantity: item.CurrentStock,
                  remarks: "",
                  barcodeNo: "",
                  MRP: item.mrp,
                  Amount: item.amount,
                });
              });
              setItemLength((prev) => prev + length);
              setItemList((prev) => [...prev, ...tempItems]);
            }
          }
        }
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleItemListChange = (value, field, index, regex) => {
    if (!value) {
      setItemList((prev) => {
        const updated = [...prev];
        updated[index][field] = value;
        updated[index][`${field}Err`] = true;
        updated[index][`${field}ErrText`] = `This field is required`;
        if (field === "lifeSpan") {
          updated[index].expiryDate = "";
        }
        return updated;
      });
    } else {
      if (!regex || regex.test(value)) {
        setItemList((prev) => {
          const updated = [...prev];

          if (field === "barcode") {
            value = value.toUpperCase();
          }
          updated[index][field] = value;
          updated[index][`${field}Err`] = false;
          updated[index][`${field}ErrText`] = "";

          if (field === "itemId") {
            let itemData = dropdownData.product.find(
              (item) => item.value === value
            );
            if (itemData) {
              updated[index].hsnCode = itemData.HSNCode;
              updated[index].gst = itemData.GstRate;
              updated[index].brandId = itemData.Brand;
              updated[index].unit = itemData.UnitId;
              updated[index].originalUnit = itemData.UnitId;
              updated[index].lifeSpan = itemData.LifeSpan;
              updated[index].mrp = itemData.mrp;
              updated[index].amount = itemData.amount;
              if (itemData.Variant) {
                updated[index].rateExcludingGST = itemData.Variant.Price;
                updated[index].rateIncludingGST = itemData.Variant.Price
                  ? itemData.Variant.Price +
                    (itemData.Variant.Price * itemData.GstRate) / 100
                  : "";
                // updated[index].batchNoList = itemData.Variant.Batches.map(
                //   (batch) => ({
                //     ...batch,
                //     label: batch.BatchNo,
                //     value: batch._id,
                //   })
                // );
              }
            }
          } else if (field === "batchNo") {
            let tempBatch = batchesList[updated[index].itemId]?.find(
              (batch) => batch.value === value
            );
            if (tempBatch) {
              updated[index].mfgDate = tempBatch.MfgDate;
              updated[index].expiryDate = tempBatch.ExpiryDate;
            }
          } else if (field === "lifeSpan") {
            if (updated[index].mfgDate) {
              updated[index].expiryDate = moment(updated[index].mfgDate)
                .add(parseInt(value), "days")
                .toDate();
            }
          }
          return updated;
        });
      }
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Enter") {
      try {
        if (itemList[idx].barcode) {
          GetVariantByBarcode(itemList[idx].barcode, idx);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const addItem = () => {
    setItemLength((prev) => prev + 1);
    setItemList((prev) => [
      ...prev,
      {
        itemId: "",
        itemName: "",
        hsnCode: "",
        hsnCodeName: "",
        brandId: "",
        brandName: "",
        gst: "",
        rateExcludingGST: "",
        rateIncludingGST: "",
        quantity: "",
        unit: "",
        unitName: "",
        totalAmountIncludingGST: "",
        mfgDate: "",
        lifeSpan: "",
        expiryDate: "",
        batchNo: "",
        toWarehouse: "",
        toWarehouseName: "",
        currentQuantity: "",
        remarks: "",
        barcodeNo: "",
        mrp: 0,
        amount: 0,
        // batchNoList: [],
      },
    ]);
  };

  const removeItem = (index) => {
    setItemList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = (type) => {
    if (type == "addSupplier") {
      setNetworkUserType("");
      setIsAddNetwork(false);
      GetSupplierList(userId);
    }
  };
  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/inward");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Inventory Inward</h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Inward Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.inwardDate
                        ? moment(formData.inwardDate).format("DD/MM/YYYY")
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Calendar
                          value={
                            formData.inwardDate
                              ? new Date(formData.inwardDate)
                              : null
                          }
                          onChange={(e) =>
                            handleFormChange(e.value, "inwardDate")
                          }
                          dateFormat="dd/mm/yy"
                          showIcon={false}
                          placeholder="Select Date"
                          className="p-w-100"
                          autoFocus
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.inwardDateErr
                          ? formData.inwardDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Order No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.orderId}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.order}
                          value={formData.orderId}
                          onChange={(e) => handleFormChange(e.value, "orderId")}
                          placeholder="Order No"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.orderIdErr ? formData.orderIdErrText : null}{" "}
                      </span>
                      {/* <div>
                        <InputText
                          value={formData.orderNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "orderNo")
                          }
                          maxLength={5}
                          placeholder="Order No"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.orderNoErr ? formData.orderNoErrText : null}{" "}
                      </span> */}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Invoice No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.invoiceNo}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.invoiceNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "invoiceNo")
                          }
                          maxLength={5}
                          placeholder="Invoice No"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.invoiceNoErr
                          ? formData.invoiceNoErrText
                          : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Process</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.processName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.process}
                          value={formData.process}
                          onChange={(e) => handleFormChange(e.value, "process")}
                          placeholder="process"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.processErr ? formData.processErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div> */}
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Process Multiplier</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.processMultiplier}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.processMultiplier}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "processMultiplier",
                              /^\d*$/i
                            )
                          }
                          maxLength={5}
                          placeholder="Enter Value"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div> */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <div className="p-d-flex p-ai-center p-jc-between">
                    <p className="p-mb-0">To Warehouse</p>
                    {readOnly ? (
                      <p className="sub-text">{formData.toWarehouseName}</p>
                    ) : (
                      <div className="p-d-flex p-mb-1">
                        <Checkbox
                          inputId="apply"
                          name="isApplyToAll"
                          onChange={(e) =>
                            handleFormChange(e.checked, "isApplyToAll")
                          }
                          checked={formData.isApplyToAll}
                          className="p-w-auto"
                        />
                        {/* <div>
                        <Dropdown
                          filter
                          options={dropdownData.warehouse}
                          value={formData.toWarehouse}
                          onChange={(e) =>
                            handleFormChange(e.value, "toWarehouse")
                          }
                          placeholder="Warehouse"
                          className="p-w-100"
                        />
                      </div> */}
                        <span className="error-msg" style={{ color: "red" }}>
                          {formData.toWarehouseErr
                            ? formData.toWarehouseErrText
                            : null}
                        </span>
                      </div>
                    )}
                  </div>
                  <div>
                    <Dropdown
                      filter
                      options={dropdownData.warehouse}
                      value={formData.toWarehouse}
                      onChange={(e) => handleFormChange(e.value, "toWarehouse")}
                      placeholder="Warehouse"
                      className="p-w-100"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="p-sm-12 p-md-3">
              <div className="flex align-items-center p-mt-4">
                <Checkbox
                  inputId="apply"
                  name="isApplyToAll"
                  onChange={(e) =>
                    handleFormChange(e.checked, "isApplyToAll")
                  }
                  checked={formData.isApplyToAll}
                />
                <label htmlFor="apply" className="p-ml-2">
                  Apply this warehouse to all
                </label>
              </div>
            </div> */}
            <div className="p-sm-12 p-md-3 p-mt-1">
              <div className="p-d-flex p-ai-center p-mt-4">
                <div className="flex align-items-center">
                  <Checkbox
                    inputId="apply"
                    name="isGst"
                    onChange={(e) => handleFormChange(e.checked, "isGst")}
                    checked={formData.isGst}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    GST
                  </label>
                </div>

                <div className="p-d-flex p-ai-center p-ml-3">
                  <Checkbox
                    inputId="apply"
                    name="isBatch"
                    onChange={(e) => handleFormChange(e.checked, "isBatch")}
                    checked={formData.isBatch}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    BATCH
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Life Span (Days)</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.lifeSpan}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.lifeSpan}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "lifeSpan",
                              /^\d*$/i
                            )
                          }
                          maxLength={5}
                          placeholder="Life Span"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.lifeSpanErr ? formData.lifeSpanErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div> */}

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Supplier Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.supplierName}</p>
                  ) : (
                    <>
                      <div className="p-d-flex p-ai-center">
                        <Dropdown
                          filter
                          options={dropdownData.supplier}
                          value={formData.supplier}
                          onChange={(e) =>
                            handleFormChange(e.value, "supplier")
                          }
                          placeholder="Supplier"
                          className="p-w-100"
                        />
                        <div /*className="p-d-flex p-pt-1 p-mt-2"*/>
                          <button
                            className="filter-btn cursor-pointer"
                            onClick={() => {
                              setIsAddNetwork(true);
                              setNetworkUserType("Supplier");
                            }}
                          >
                            {" "}
                            <i className="icon-add"></i>{" "}
                          </button>
                        </div>
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.supplierErr ? formData.supplierErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">GSTIN</p>
                    {readOnly ? (
                      <p className="sub-text">{formData.gstin}</p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.gstin}
                            onChange={(e) =>
                              handleFormChange(e.target.value, "gstin")
                            }
                            maxLength={5}
                            placeholder="GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>

                        {/* <div>
                        <Dropdown
                          options={dropdownData.gstRates}
                          value={formData.gstin}
                          onChange={(e) => handleFormChange(e.value, "gstin")}
                          placeholder="GST"
                        />
                      </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">
                    {formData.isGst ? "Total Amt (Excl. GST)" : "Total Amt"}
                  </p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.isGst
                        ? formData.totalAmountExcludingGST
                        : itemList?.length
                        ? itemList?.reduce(
                            (a, b) => Number(a) + Number(b.amount),
                            0
                          ) *
                          itemList?.reduce(
                            (a, b) => Number(a) + Number(b.quantity),
                            0
                          )
                        : 0.0}
                    </p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={
                            formData.isGst
                              ? formData.totalAmountExcludingGST
                              : itemList?.length
                              ? Number(
                                  itemList?.reduce(
                                    (a, b) =>
                                      Number(a) + Number(b.rateExcludingGST),
                                    0
                                  )
                                ) *
                                Number(
                                  itemList?.reduce(
                                    (a, b) => Number(a) + Number(b.quantity),
                                    0
                                  )
                                )
                              : 0.0
                          }
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "totalAmountExcludingGST",
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder={
                            formData.isGst
                              ? "Amount excluding GST"
                              : "Total Amt"
                          }
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">Total Amt (Incl. GST)</p>
                    {readOnly ? (
                      <p className="sub-text">
                        {formData.totalAmountIncludingGST}
                      </p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.totalAmountIncludingGST}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "totalAmountIncludingGST",
                                /^\d+(\.\d{0,2})?$/i
                              )
                            }
                            maxLength={10}
                            placeholder="Amount including GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Total MRP</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {itemList?.length
                        ? itemList?.reduce(
                            (a, b) => Number(a) + Number(b.mrp),
                            0
                          ) *
                          itemList?.reduce(
                            (a, b) => Number(a) + Number(b.quantity),
                            0
                          )
                        : 0.0}
                    </p>
                  ) : (
                    <InputText
                      disabled
                      className="p-w-100"
                      value={
                        itemList?.length
                          ? itemList?.reduce(
                              (a, b) => Number(a) + Number(b.mrp),
                              0
                            ) *
                            itemList?.reduce(
                              (a, b) => Number(a) + Number(b.quantity),
                              0
                            )
                          : 0.0
                      }
                      onChange={(e) =>
                        handleFormChange(e.target.value, "totalMRP")
                      }
                      maxLength={200}
                      placeholder="Total MRP"
                    />
                  )}
                </div>
              </div>
            </div>
            {/* <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Total Amount</p>
                  {readOnly ? (
                    <p className="sub-text">{itemList?.length ? itemList?.reduce((a, b) => Number(a) + Number(b.amount), 0) : 0.00}</p>
                  ) : (
                    <InputText
                      disabled
                      className="p-w-100"
                      value={itemList?.length ? itemList?.reduce((a, b) => Number(a) + Number(b.amount), 0) : 0.00}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "totalAmount")
                      }
                      maxLength={200}
                      placeholder="Total MRP"
                    />
                  )}
                </div>
              </div>
            </div> */}
            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.remarks}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.remarks}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "remarks")
                      }
                      maxLength={200}
                      placeholder="Remarks"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {itemList.map((item, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                // padding: '24px',
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Item {vIdx + 1}
                </span>
                {!readOnly && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeItem(vIdx)}
                    style={{
                      minWidth: 120,
                      borderRadius: 8,
                      fontWeight: 500,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      background: "#fff",
                    }}
                  >
                    <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                    Delete Item
                  </Button>
                )}
              </div>
              <div className="p-grid p-px-4">
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Item Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.itemName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.product}
                              value={item.itemId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "itemId", vIdx)
                              }
                              placeholder="Item"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.itemErr ? item.itemErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{item.barcode}</p>
                      ) : (
                        <InputText
                          value={item.barcode}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "barcode",
                              vIdx
                            )
                          }
                          onKeyDown={(e) => handleKeyDown(e, vIdx)}
                          maxLength={50}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">HSN Code</p>
                        {readOnly ? (
                          <p className="sub-text">{item.hsnCodeName}</p>
                        ) : (
                          <>
                            <div>
                              <Dropdown
                                filter
                                options={dropdownData.hsnCode}
                                value={item.hsnCode}
                                onChange={(e) =>
                                  handleItemListChange(e.value, "hsnCode", vIdx)
                                }
                                placeholder="HSN Code"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {item.hsnCodeErr ? item.hsnCodeErrText : null}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Brand Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.brandName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.brands}
                              value={item.brandId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "brandId", vIdx)
                              }
                              placeholder="Brand Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.brandErr ? item.brandErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">
                            {formData.isGst ? "Rate (Excl. of GST)" : "Rate"}
                          </p>
                          {readOnly ? (
                            <p className="sub-text">{item.rateExcludingGST}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.rateExcludingGST}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "rateExcludingGST",
                                      vIdx,
                                      /^\d+(\.\d{0,2})?$/i
                                    )
                                  }
                                  maxLength={15}
                                  placeholder="Rate"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">GST %</p>
                          {readOnly ? (
                            <p className="sub-text">{item.gst}</p>
                          ) : (
                            <>
                              {/* <div>
                            <InputText
                              value={item.gst}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "gst",
                                  vIdx,
                                  /^\d*$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                            />
                          </div> */}

                              <div>
                                <Dropdown
                                  filter
                                  options={dropdownData.gstRates}
                                  value={item.gst}
                                  onChange={(e) =>
                                    handleItemListChange(e.value, "gst", vIdx)
                                  }
                                  placeholder="GST"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {" "}
                        {formData.isGst ? "Rate (Incl. of GST)" : "Rate"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.rateIncludingGST}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.rateIncludingGST}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "rateIncludingGST",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.quantity}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.quantity}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "quantity",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={10}
                              placeholder="Quantity"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.quantityErr ? item.quantityErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Unit</p>
                      {readOnly ? (
                        <p className="sub-text">{item.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={item.unit}
                              onChange={(e) =>
                                handleItemListChange(e.value, "unit", vIdx)
                              }
                              placeholder="Unit"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.unitErr ? item.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">Total Amount (Incl. GST)</p>
                        {readOnly ? (
                          <p className="sub-text">
                            {item.totalAmountIncludingGST}
                          </p>
                        ) : (
                          <>
                            <div>
                              <InputText
                                value={item.totalAmountIncludingGST}
                                onChange={(e) =>
                                  handleItemListChange(
                                    e.target.value,
                                    "totalAmountIncludingGST",
                                    vIdx,
                                    /^\d+(\.\d{0,2})?$/i
                                  )
                                }
                                maxLength={15}
                                placeholder="Amount"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                {formData.isBatch ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">MFG Date </p>
                          {readOnly ? (
                            <p className="sub-text">
                              {item.mfgDate
                                ? moment(item.mfgDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <>
                              <div>
                                <Calendar
                                  value={
                                    item.mfgDate ? new Date(item.mfgDate) : null
                                  }
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.value,
                                      "mfgDate",
                                      vIdx
                                    )
                                  }
                                  dateFormat="dd/mm/yy"
                                  showIcon={false}
                                  placeholder="Select MFG Date"
                                  className="p-w-100"
                                  disabled={readOnly}
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {item.mfgDateErr ? item.mfgDateErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Lifespan</p>
                          {readOnly ? (
                            <p className="sub-text">{item.lifeSpan}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.lifeSpan}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "lifeSpan",
                                      vIdx,
                                      /^\d*$/i
                                    )
                                  }
                                  maxLength={10}
                                  placeholder="Life Span"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Expiry Date</p>
                          {readOnly ? (
                            <p className="sub-text">
                              {item.expiryDate
                                ? moment(item.expiryDate).format("DD/MM/YYYY")
                                : ""}
                            </p>
                          ) : (
                            <Calendar
                              value={
                                item.expiryDate
                                  ? new Date(item.expiryDate)
                                  : null
                              }
                              onChange={(e) =>
                                handleItemListChange(
                                  e.value,
                                  "expiryDate",
                                  vIdx
                                )
                              }
                              dateFormat="dd/mm/yy"
                              showIcon={false}
                              placeholder="Select Expiry Date"
                              className="p-w-100"
                              disabled={readOnly}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Batch No</p>
                          {readOnly ? (
                            <p className="sub-text">{item.batchNoName}</p>
                          ) : (
                            <>
                              <div>
                                <Dropdown
                                  filter
                                  options={batchesList[item.itemId] || []}
                                  value={item.batchNo}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.value,
                                      "batchNo",
                                      vIdx
                                    )
                                  }
                                  placeholder="Batch No"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                              <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {item.batchNoErr ? item.batchNoErrText : null}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">To Warehouse</p>
                      {readOnly ? (
                        <p className="sub-text">{item.toWarehouseName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.warehouse}
                              value={item.toWarehouse}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.value,
                                  "toWarehouse",
                                  vIdx
                                )
                              }
                              placeholder="Warehouse"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.warehouseErr ? item.warehouseErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Current Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.currentQuantity}</p>
                      ) : (
                        <InputText
                          value={item.currentQuantity}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "currentQuantity",
                              vIdx,
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="Current Quantity"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">MRP</p>
                      {readOnly ? (
                        <p className="sub-text">{item.mrp}</p>
                      ) : (
                        <InputText
                          value={item.mrp}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "mrp",
                              vIdx,
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={15}
                          placeholder="MRP"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Total Amount (Excl. GST)</p>
                      {readOnly ? (
                        <p className="sub-text">{item.amount}</p>
                      ) : (
                        <InputText
                          value={
                            Number(item?.rateExcludingGST) *
                            Number(item?.quantity)
                          }
                          onChange={(e) =>
                            handleItemListChange(e.target.value, "amount", vIdx)
                          }
                          maxLength={10}
                          placeholder="Amount"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Remarks</p>
                      {readOnly ? (
                        <p className="sub-text">{item.remarks}</p>
                      ) : (
                        <InputTextarea
                          className="p-w-100"
                          value={item.remarks}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "remarks",
                              vIdx
                            )
                          }
                          maxLength={200}
                          placeholder="Remarks"
                        />
                      )}
                    </div>
                  </div>
                </div>
                {/* Delete button moved to header row above */}
              </div>
              {/* <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">Barcode</p>
                    {readOnly ? (
                      <p className="sub-text">{item.barcode}</p>
                    ) : (
                      <InputText
                        value={item.barcode}
                        onChange={(e) =>
                          handleItemListChange(e.target.value, "barcode", vIdx)
                        }
                        maxLength={10}
                        placeholder="Barcode"
                        className="p-w-100 e-input-common"
                      />
                    )}
                  </div>
                </div>
              </div> */}

              {/* {!readOnly && (
                <>
                  <Button onClick={() => removeItem(vIdx)}>Delete Item</Button>
                </>
              )} */}
            </div>
          ))}
          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addItem}
              className="add-item-btn"
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add Item
            </Button>
          )}
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => {
            props.history.push("/admin/inward");
          }}
        >
          Cancel
        </button>
        {readOnly ? null : (
          <Button
            className="primary-btn color-white p-ml-1"
            onClick={AddInward}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit"}
          </Button>
        )}
      </div>

      <Dialog
        visible={isAddNetwork}
        onHide={() => handleClose("addSupplier")}
        draggable={false}
        position="center"
        style={{ width: "60vw" }}
      >
        <AddMyNetwork
          handleClose={handleClose}
          networkUserType={networkUserType}
          isAddNetwork={isAddNetwork}
          {...props}
        />
      </Dialog>
    </div>
  );
};

export default AddInward;
